
import { Injectable } from '@angular/core';
import { applicationPaths, localStorageKeys, screenDetails } from '../Models/configurations';
import { stepNavigation } from '../Models/step-navigation-constant';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AppsettingService {

  private stepObjArray: any;

  ScreenDetails: any;
  IsAdvice: boolean;
  IsCurrentOffer: boolean;
  IsPrivacyConsent: boolean;
  IsDeliverNotify: boolean;
  IsBackBtnBackFlag:boolean;

  constructor(
    private readonly secureStorageService: SecureStorageService,
  ) { }

  public returnAction(actionName: string): string {
    return `${actionName}`;
  }



  public fetchSiteElements(): any[] {
    const IsCurrentOfferEnable =  this.secureStorageService.getKeyData(localStorageKeys.checkingModule).isEnable;
    if(IsCurrentOfferEnable)
    {
      return stepNavigation;
    }
    else{
      const updatedStepNavigation=stepNavigation;
      const id = 2;
      updatedStepNavigation.splice(id,  1);
      return updatedStepNavigation;
    }
  }

  public getScreenConfiguration(screenName: string) {
    this.IsAdvice = false;
    this.IsCurrentOffer =  this.secureStorageService.getKeyData(localStorageKeys.checkingModule).isEnable;

    if (screenName === screenDetails.stepTwo) {
      return '/' + applicationPaths.fourth;
    }

    if (screenName === screenDetails.stepThree) {
      return '/' + applicationPaths.seven;
    }

    if (screenName === screenDetails.stepFour) {
      if (this.IsCurrentOffer) {
          return '/' + applicationPaths.six;
      } else {
          return '/' + applicationPaths.third;
      }
    }
    if (screenName === screenDetails.stepSix) {
      return '/' + applicationPaths.third;
    }
  }


  public stepCompletion(stepName: string, _value: boolean) {
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus)) {
      this.stepObjArray = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
      let stateChange = this.stepObjArray.find(ele => ele.Key === stepName);
      let index = this.stepObjArray.indexOf(stateChange);
      if(this.stepObjArray[index+1] != undefined)
      {
        this.stepObjArray[index+1].isActive = true;
        stateChange.isStage = true;
      }
      this.secureStorageService.removeKey(localStorageKeys.stepStatus);
      this.secureStorageService.setKeyData(localStorageKeys.stepStatus, this.stepObjArray);
    }
  }

}
